function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 0h31v4H0zm0 10h31v4H0zm0 10h31v4H0z",
  fill: "#212121",
  fillRule: "evenodd"
});

function SvgOpenIcon(props) {
  return React.createElement("svg", _extends({
    width: 31,
    height: 24
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzEiIGhlaWdodD0iMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzIxMjEyMSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMCAwaDMxdjRIMHpNMCAxMGgzMXY0SDB6TTAgMjBoMzF2NEgweiIvPjwvZz48L3N2Zz4=";
export { SvgOpenIcon as ReactComponent };